import React from "react";

import { Layout, Skeleton, SpacingSize } from "@multiweb/reactComponents";
import { PlaceholderComponent } from "../../../LiteListFrameGeneralAttributeComponent";

export const LiteListFrameSkeletonIconAttributePlaceholder: PlaceholderComponent = ({
    backgroundAttributeName,
}) => (
    <Layout spacingSizeHorizontal={backgroundAttributeName ? SpacingSize.xxs : undefined}>
        <Skeleton circle height={"var(--icon-small-font-size)"} width={"var(--icon-small-font-size)"} />
    </Layout>
);
